module.exports = __webpack_public_path__ + "img/icon_img_10.3f423653.png";